import RegularText from '@/components/RegularText';
import { SETTING_TYPE, LocationViewChoices } from '@/constants/enum';
import { isEmpty } from '@/helpers';
import { IListLocation } from '@/types/components/location';
import { Badge, BlockStack, Button, IndexTable, Tooltip } from '@shopify/polaris';
import { DeleteIcon, EditIcon, NoteAddIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';

type TRowTableLocation = {
  item: IListLocation;
  index: number;
  handleShowDetailLocation: (id: number) => void;
  selectedView: number;
  textStatus: {
    textOn: string;
    textOff: string;
  };
  handleShowModalDeleteLocation: (id: number) => void;
  handleEditPickupSettings: (id: number) => void;
};

const RowTableLocations = ({
  item,
  index,
  handleShowDetailLocation,
  selectedView,
  textStatus,
  handleShowModalDeleteLocation,
  handleEditPickupSettings,
}: TRowTableLocation) => {
  const { t } = useTranslation('locations');

  return (
    <IndexTable.Row id={item.id.toString()} key={item.id + selectedView} position={index}>
      <IndexTable.Cell>
        <BlockStack gap={'100'} align="start">
          <Button variant="plain" textAlign="left" onClick={() => handleShowDetailLocation(item.id)}>
            {item?.name ?? ''}
          </Button>
          <RegularText>
            {item?.address?.address1}
            {!isEmpty(item.address?.city) ? ', ' + item.address?.city : ''}
            {!isEmpty(item.address?.province) ? ', ' + item.address?.province : ''}
            {!isEmpty(item.address?.postalCode) ? ', ' + item.address?.postalCode : ''}
            {!isEmpty(item.address?.country) ? ', ' + item.address?.country : ''}
          </RegularText>
        </BlockStack>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Badge tone={item.isEnablePickup ? 'success' : undefined}>
          {item.isEnablePickup ? textStatus.textOn : textStatus.textOff}
        </Badge>
      </IndexTable.Cell>
      {selectedView === LocationViewChoices.ALL && (
        <IndexTable.Cell>
          <Badge tone={item.isEnableDelivery ? 'success' : undefined}>
            {item.isEnableDelivery ? textStatus.textOn : textStatus.textOff}
          </Badge>
        </IndexTable.Cell>
      )}
      <IndexTable.Cell>
        {selectedView === LocationViewChoices.ALL && (
          <Tooltip content={t('tableLocation.delete')}>
            <Button variant="plain" tone="critical" icon={DeleteIcon} onClick={() => handleShowModalDeleteLocation(item.id)} />
          </Tooltip>
        )}
        {selectedView === LocationViewChoices.PICKUP && (
          <Button
            onClick={() => {
              handleEditPickupSettings(Number(item.settings.find((item) => item.type === SETTING_TYPE.PICKUP)?.id));
            }}
            variant="plain"
            icon={EditIcon}
          >
            {t('tableLocation.editSettings')}
          </Button>
        )}
        {selectedView === LocationViewChoices.DELIVERY && (
          <Button variant="plain" icon={NoteAddIcon}>
            {t('tableLocation.addDeliveryZone')}
          </Button>
        )}
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

export default RowTableLocations;
